/* eslint semi:0 */
import React from 'react'
import { isDesktop } from 'utils/ua'
import { findDOMNode, } from 'react-dom'
import ReactionsComponent from './reactionsComponent'
import { t, } from 'providers/i18nProvider/i18nProvider'
import ShareButtonsComponent from './shareButtonsComponent'
import { addDocumentEvent, removeDocumentEvent, } from 'utils/dom'


const BLOCK_NAME = 'social-bar-container'
const noClickOutsideComponentHandler = null

let didFetchReactions = false // todo: this is a temp hack fix,
// the ideal solution would be to include this prop inside react's state
export default class SocialBarComponent extends React.Component {

  constructor(){
    super(...arguments)
    this.state = {
      checkboxChecked: false
    }
    this.toggleCheckbox = this.toggleCheckbox.bind(this)
    this.clickOutsideComponentHandler = noClickOutsideComponentHandler
  }

  componentDidMount(){
    const {
      reactionsComponentInitialState,
      setReactionsComponentState,
    } = this.props
    setReactionsComponentState(reactionsComponentInitialState)
    this.getPostVotesOnce()
  }

  componentWillUnmount(){
    this.removeCloseOutsideComponentHandler()
    const {
      componentPosition,
      reactionsComponentState,
      setReactionsComponentState,
    } = this.props
    setReactionsComponentState({
      ...reactionsComponentState,
      removePosition: componentPosition,
    })
  }

  addCloseOutsideComponentHandler(){
    if (!this.clickOutsideComponentHandler) {
      const globalClickHandler = this.globalClickHandler = this.handleGlobalClicks.bind(this)
      const globalScrollHandler = this.globalScrollHandler = this.handleGlobalClicks.bind(this)
      const globalTouchHandler = this.globalTouchHandler = this.handleGlobalClicks.bind(this)
      const globalMoveHandler = this.globalMoveHandler = this.handleGlobalClicks.bind(this)
      // next tick is required because otherwise the
      // handler is triggered immediately after it is added.
      setImmediate(
        () => {
          if (isDesktop) {
            addDocumentEvent('click', globalClickHandler, true)
            addDocumentEvent('scroll', globalScrollHandler, true)
          } else {
            addDocumentEvent('touchstart', globalTouchHandler, true)
            addDocumentEvent('touchmove', globalMoveHandler, true)
          }
        }
      )
    }
  }

  removeCloseOutsideComponentHandler(){
    const { globalClickHandler, globalScrollHandler, globalTouchHandler, globalMoveHandler } = this
    if (globalClickHandler && globalScrollHandler && globalTouchHandler && globalMoveHandler) {
      if (isDesktop) {
        removeDocumentEvent('click', globalClickHandler, true)
        removeDocumentEvent('scroll', globalScrollHandler, true)
        this.globalClickHandler = noClickOutsideComponentHandler
        this.globalScrollHandler = noClickOutsideComponentHandler
      } else {
        removeDocumentEvent('touchstart', globalTouchHandler, true)
        removeDocumentEvent('touchmove', globalMoveHandler, true)
        this.globalTouchHandler = noClickOutsideComponentHandler
        this.globalMoveHandler = noClickOutsideComponentHandler
      }
    }
    this.setState({
      checkboxChecked: false
    })
  }

  getPostVotesOnce(){
    const { getPostVotes, postId, } = this.props
    if (didFetchReactions) {
      return
    }
    didFetchReactions = true
    getPostVotes({ postId, })
  }

  onReactionsButtonClick(e){
    const { areReactionsVisible, props, } = this
    const {
      hideReactions,
      displayReactions,
      componentPosition,
    } = props
    if (areReactionsVisible) {
      hideReactions(componentPosition)
    } else {
      displayReactions(componentPosition)
      this.addCloseOutsideComponentHandler()
      this.getPostVotesOnce()
    }
  }

  onReactionClicked({ reactionId, }){
    const {
      postId,
      sendVote,
      selectedReaction,
      componentPosition,
    } = this.props
    if (selectedReaction) {
      return
    }
    sendVote({ postId, reactionId, componentPosition, })
    this.getPostVotesOnce()
  }

  handleGlobalClicks(e){
    const { areReactionsVisible, props, } = this
    const {
      hideReactions,
      componentPosition,
      reactionsComponentInitialState,
      selectedReaction: didUserAlreadyVote,
    } = props
    const thisDomNode = findDOMNode(this)
    const isThisTheActiveComponent = !!thisDomNode
    if (!isThisTheActiveComponent) {
      return
    }
    this.removeCloseOutsideComponentHandler()
    const isInitialStateVisible =
      reactionsComponentInitialState[componentPosition].isVisible
    if (!areReactionsVisible || isInitialStateVisible) {
      return
    }
    const hideReactionsAndStopPropogation = () => {
      e.stopPropagation()
      hideReactions(componentPosition)
    }
    if (didUserAlreadyVote) {
      e.stopPropagation()
      const didUserTryToCloseReactions = !thisDomNode.contains(e.target)
      if (didUserTryToCloseReactions) {
        hideReactions(componentPosition)
      }
    } else {
      const didUserClickToVote = thisDomNode.contains(e.target)
      if (!didUserClickToVote) {
        hideReactionsAndStopPropogation()
      }
    }
  }

  get areReactionsVisible(){
    const { componentPosition, reactionsComponentState, } = this.props
    if (!(componentPosition in reactionsComponentState)) {
      return false
    }
    return reactionsComponentState[componentPosition].isVisible
  }

  createReactionsComponent(){
    const {
      reactions,
      percentages,
      selectedReaction,
      title,
    } = this.props
    if (!this.areReactionsVisible) {
      return null
    }
    const { reactions: reactionsList, campaign = {}, } = reactions
    const { image: headerImage, }  = campaign
    const headerText = t('reactions.campaigns_poweredby')
    const reactionsComponentProps = {
      headerText,
      title,
      headerImage,
      percentages,
      selectedReaction,
      reactions: reactionsList,
      onReactionClicked: this.onReactionClicked.bind(this),
      onReactionsListContainerClick:
        this.onReactionsListContainerClick.bind(this),
    }
    return <ReactionsComponent { ...reactionsComponentProps } />
  }
  onReactionsListContainerClick(){
    this.addCloseOutsideComponentHandler()
  }

  toggleCheckbox(e) {
    const { areReactionsVisible, props, state, } = this
    const { hideReactions, componentPosition, } = props
    if (areReactionsVisible) {
      hideReactions(componentPosition)
    }
    e.nativeEvent.stopImmediatePropagation()
    this.setState({
      checkboxChecked: !state.checkboxChecked
    })
    this.addCloseOutsideComponentHandler()
  }

  createShareButtonsComponent(){
    const {
      props: { shareButtons },
      state: { checkboxChecked, },
      toggleCheckbox,
    } = this
    const shareButtonsComponentProps = { shareButtons, checkboxChecked, toggleCheckbox, }
    return <ShareButtonsComponent { ...shareButtonsComponentProps } />
  }

  get reactionsButtonInlineStyle(){
    const {
      selectedReaction,
      reactions: {
        reactions, default_icon: defaultIcon,
      },
    } = this.props
    let imageUrl
    if (selectedReaction) {
      const reaction = reactions.find(r => r.id === selectedReaction)
      const { selected_image: selectedImage, } = reaction
      imageUrl = selectedImage
    } else {
      imageUrl = defaultIcon
    }
    return { backgroundImage: `url('${ imageUrl }')`, }
  }

  get blockClassNames(){
    const { selectedReaction, reactions: { campaign, }} = this.props
    const reactedModifier = selectedReaction ? 'reacted' : 'unreacted'
    const campaignModifier = campaign ? 'campaign' : ''
    const modifiers = [reactedModifier, campaignModifier, ]
      .filter(mod => !!mod)
      .map(mod => `${ BLOCK_NAME }--${ mod }`)
      .join(' ')
    return `${ BLOCK_NAME } ${ modifiers }`
  }

  get isComponentVisible(){
    const { isInCoverViewport, componentPosition, } = this.props
    if (componentPosition === 'details') {
      return true
    }
    if (isInCoverViewport && componentPosition === 'header') {
      return false
    }
    return true
  }

  render(){
    if (!this.isComponentVisible){
      return false
    }
    return (
      <section className={ this.blockClassNames }>
        { this.createReactionsComponent() }
        <div
          style={ this.reactionsButtonInlineStyle }
          className={ `${ BLOCK_NAME }__reactions` }
          onClick={ this.onReactionsButtonClick.bind(this) }
        />
        <div className={ `${ BLOCK_NAME }__share` }>{ this.createShareButtonsComponent() }</div>
      </section>
    )
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/socialBarComponent.js